import {StyleSheet, PixelRatio, StatusBar, Platform} from 'react-native';
import theme from '@qnpm/q-theme';

const {
    responsive: { scale }
} = theme;

export default StyleSheet.create({
    loadingWrapper:{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 18,
        marginBottom: 10,
        zIndex: 99
    },
    loadingText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 12,
        marginLeft: 4,
        color: "#00CAD8",
    },
    loaingImg: {
        height: scale(12),
        width: scale(12)
    }
});